import React from 'react'
import { TemplateContainer } from '../../containers/dashboard/template'

export default function EditWebsite({accessToken, name, email, isActive, isSuperuser}) {
    return (
    <TemplateContainer pageName={'Edit Website'} email={email} 
    name={name} 
    accessToken={accessToken}
    isActive={isActive}
    isSuperuser={isSuperuser}
    />)
}

